const { createSlice } = require("@reduxjs/toolkit");

const defaultTheme = JSON.stringify({
  background: "#E6E6E6",
  text: "#333C4D",
  btnBg: "#ffffff",
  btnText: "#333C4D",
});

// Initial State
const initialState = {
  userData: {
    username: "",
    address: "",
    createdAt: "",
    email: "",
    phone: "",
    name: "",
    services: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    logo: "",
    selectedTemplate: "",
    tiktok: "",
    timing: "",
    youtube: "",
    x: "",
    updatedAt: "",
    paidWidgets: [], // Add paidWidgets to store purchased features
  },
  token: null,
  accountID: "",
  isLoading: false,
  widgets: [], // <-- add widgets to state
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.token = action.payload.token;
    },
    updateUserDetailsInReducer(state, action) {
      state.userData = { ...state.userData, ...action.payload };
    },
    updateLoader(state, action) {
      state.isLoading = action.payload;
    },
    logout(state) {
      localStorage.clear();
      state = { ...initialState };
      window.location.reload();
    },
    setWidgets(state, action) {
      state.widgets = action.payload;
    },
    addWidget(state, action) {
      state.widgets.push(action.payload);
    },
    editWidget(state, action) {
      const { index, key, value } = action.payload;
      if (state.widgets[index]) {
        state.widgets[index][key] = value;
        state.widgets[index].isEditing = false;
      }
    },
    deleteWidget(state, action) {
      state.widgets.splice(action.payload, 1);
    },
  },
});

export const {
  login,
  updateUserDetailsInReducer,
  logout,
  completeFirstTimeSetup,
  updateLoader,
  setWidgets,
  addWidget,
  editWidget,
  deleteWidget,
} = authSlice.actions;

export const getUserDetailsFromReducer = (state) => state?.auth?.userData;
export const getUserNameFromReducer = (state) =>
  state?.auth?.userData?.username;

export const getThemeColor = (state) =>
  state?.auth?.userData?.themeColor || defaultTheme;

export const getTokenFromReducer = (state) => state?.auth?.token;
export const getLoaderState = (state) => state?.auth?.isLoading;
export const getWidgetsFromReducer = (state) => state?.auth?.widgets;

export default authSlice.reducer;
